"use client";

import { useTranslations } from "next-intl";
import { SurfaceChrome } from "@/components/SurfaceChrome";
import type { BottomNavItem } from "@/components/ui/BottomNav";
import {
  IconGauge,
  IconCalendar,
  IconChat,
  IconWallet,
  IconUser,
} from "@/components/ui/icons";

/**
 * Navegación de la superficie TERAPEUTA (/pro). Client component (íconos =
 * componentes). Otros agentes: agreguen/renombren rutas acá.
 */
export function ProNav({ children }: { children: React.ReactNode }) {
  const t = useTranslations("common");
  const tb = useTranslations("common.brand");

  const items: BottomNavItem[] = [
    { href: "/pro", label: t("nav.overview"), icon: IconGauge, exact: true },
    { href: "/pro/schedule", label: t("nav.schedule"), icon: IconCalendar },
    { href: "/pro/messages", label: t("nav.messages"), icon: IconChat },
    { href: "/pro/earnings", label: t("nav.earnings"), icon: IconWallet },
    { href: "/pro/profile", label: t("nav.profile"), icon: IconUser },
  ];

  return (
    <SurfaceChrome items={items} brand={`${tb("name")} · Pro`}>
      {children}
    </SurfaceChrome>
  );
}
